"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "imola": {
    "5fb75a96": [{
      "hkey": "1eaaf18c",
      "slug": "pedagna",
      "name": "Pedagna",
      "primary": true,
      "skipSearch": false
    }],
    "carlina": [{
      "hkey": "1eaaf18c",
      "slug": "pedagna",
      "name": "Pedagna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "imola"
    }],
    "b4958afe": [{
      "hkey": "ba157dbd",
      "slug": "centro-storico",
      "name": "Centro Storico",
      "primary": true,
      "skipSearch": false
    }],
    "centro": [{
      "hkey": "ba157dbd",
      "slug": "centro-storico",
      "name": "Centro Storico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "713d605e": [{
      "hkey": "1eaaf18c",
      "slug": "pedagna",
      "name": "Pedagna",
      "primary": true,
      "skipSearch": false
    }],
    "montecatone": [{
      "hkey": "1eaaf18c",
      "slug": "pedagna",
      "name": "Pedagna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "imola"
    }],
    "ac70e05b": [{
      "hkey": "4c8d5504",
      "slug": "imola",
      "name": "Imola",
      "primary": true,
      "skipSearch": false
    }],
    "montericco": [{
      "hkey": "4c8d5504",
      "slug": "imola",
      "name": "Imola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "16248269": [{
      "hkey": "1eaaf18c",
      "slug": "pedagna",
      "name": "Pedagna",
      "primary": true,
      "skipSearch": false
    }],
    "pedagna-est": [{
      "hkey": "1eaaf18c",
      "slug": "pedagna",
      "name": "Pedagna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "imola"
    }],
    "3e69c508": [{
      "hkey": "1eaaf18c",
      "slug": "pedagna",
      "name": "Pedagna",
      "primary": true,
      "skipSearch": false
    }],
    "pedagna-ovest": [{
      "hkey": "1eaaf18c",
      "slug": "pedagna",
      "name": "Pedagna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "imola"
    }],
    "395e99a7": [{
      "hkey": "4c8d5504",
      "slug": "imola",
      "name": "Imola",
      "primary": true,
      "skipSearch": false
    }],
    "pontesanto": [{
      "hkey": "4c8d5504",
      "slug": "imola",
      "name": "Imola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6968b729": [{
      "hkey": "6d4f9027",
      "slug": "tre-monti",
      "name": "Tre Monti",
      "primary": true,
      "skipSearch": false
    }],
    "rivazza": [{
      "hkey": "6d4f9027",
      "slug": "tre-monti",
      "name": "Tre Monti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "imola"
    }],
    "836d38c1": [{
      "hkey": "adb43c5b",
      "slug": "zona-industriale-villaggio",
      "name": "Zona industriale-Villaggio",
      "primary": true,
      "skipSearch": false
    }],
    "villaggio": [{
      "hkey": "adb43c5b",
      "slug": "zona-industriale-villaggio",
      "name": "Zona industriale-Villaggio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "imola"
    }],
    "6efefe83": [{
      "hkey": "adb43c5b",
      "slug": "zona-industriale-villaggio",
      "name": "Zona industriale-Villaggio",
      "primary": true,
      "skipSearch": false
    }],
    "zona-industriale": [{
      "hkey": "adb43c5b",
      "slug": "zona-industriale-villaggio",
      "name": "Zona industriale-Villaggio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "imola"
    }]
  }
};
exports["default"] = _default;